// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import CoApplicantActionType from './co-applicant.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	// Co Applicant Object
	coApplicantObj: null,
	// Co Applicants List Array
	coApplicantsListArr: [],
	// Update Co Applicant Response
	updateCoApplicantResponse: null,
	// Add Co Borrower Response
	addcoBorrowerResponse: null,
	// Fetch Co Applicant Response
	fetchCoApplicantResp: null,
	// Fetch Co Applicant Array
	fetchCoApplicantArr: null,
	// Delete Co Applicant Response
	deleteCoApplicantResp: null,
	// Co Applicant High Mark Response
	coApplicantHighMarkResp: null,
	// Co Applicant High Mark Array
	coApplicantHighMarkArr: [],
	// Verify Co Applicant Aadhar OTP Response
	verifyCoApplicantAadharOtpResp: null,
	// Verify Co Applicant Aadhar OTP Result
	verifyCoApplicantAadharOtpResult: [],
	// Verify Validate Co Applicant Aadhar OTP Response
	verifyValidateCoApplicantAadharOtpResp: null,
	// Verify Validate Co Applicant Aadhar OTP Result
	verifyValidateCoApplicantAadharOtpResult: [],
	
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD CO-APPLICANT START *********************** */
		case CoApplicantActionType.ADD_CO_APPICANT_DETAILS_START:
			return { ...state, coApplicantObj: action.payload };

		case CoApplicantActionType.ADD_COBORROWER_SUCCESS:
		case CoApplicantActionType.ADD_COBORROWER_FAILURE:
			return { ...state, addcoBorrowerResponse: action.payload };

		case CoApplicantActionType.ADD_COBORROWER_RESPONSE_CHANGED:
			return { ...state, addcoBorrowerResponse: null };
		/** ***************** ADD CO-APPLICANT END *********************** */

		/** ***************** UPDATE CO-APPLICANT START *********************** */
		case CoApplicantActionType.UPDATE_CO_APPICANT_DETAILS_START:
			return { ...state, coApplicantObj: null };

		case CoApplicantActionType.UPDATE_CO_APPLICANT_SUCCESS:
		case CoApplicantActionType.UPDATE_CO_APPLICANT_FAILURE:
			return { ...state, updateCoApplicantResponse: action.payload };

		case CoApplicantActionType.UPDATE_CO_APPLICANT_RESPONSE_CHANGED:
			return { ...state, updateCoApplicantResponse: null };
		/** ***************** UPDATE CO-APPLICANT END *********************** */

		/** ***************** FETCH CO-APPLICANT START *********************** */
		case CoApplicantActionType.FETCH_COBORROWER_SUCCESS:
			return {
				...state,
				fetchCoApplicantResp: action.payload,
				fetchCoApplicantArr: docodeHexResponse(action.payload, 'FetchMemberDataKey'),
			};

		case CoApplicantActionType.FETCH_COBORROWER_FAILURE:
			return { ...state, fetchCoApplicantResp: action.payload };

		case CoApplicantActionType.FETCH_COBORROWER_RESPONSE_CHANGED:
			return { ...state, fetchCoApplicantResp: null };

		case CoApplicantActionType.COBORROWER_OBJECT_RESET:
			return { ...state, fetchCoApplicantArr: null };
		/** ***************** FETCH CO-APPLICANT END *********************** */

		/** ***************** DELETE CO-APPLICANT START *********************** */
		case CoApplicantActionType.DELETE_CO_APPLICANT_SUCCESS:
		case CoApplicantActionType.DELETE_CO_APPLICANT_FAILURE:
			return { ...state, deleteCoApplicantResp: action.payload };

		case CoApplicantActionType.DELETE_CO_APPLICANT_RESPONSE_CHANGED:
			return { ...state, deleteCoApplicantResp: null };
		/** ***************** DELETE CO-APPLICANT END *********************** */

		/** ***************** HIGHMARK CHECK START *********************** */
		case CoApplicantActionType.CHECK_COBORROWER_HIGHMARK_SUCCESS:
			return {
				...state,
				coApplicantHighMarkResp: action.payload,
				coApplicantHighMarkArr: docodeHexResponse(action.payload, 'CoBorrowerCrifCheckKey'),
			};

		case CoApplicantActionType.CHECK_COBORROWER_HIGHMARK_FAILURE:
			return { ...state, coApplicantHighMarkResp: action.payload };

		case CoApplicantActionType.CHECK_COBORROWER_HIGHMARK_RESPONSE_CHANGED:
			return { ...state, coApplicantHighMarkResp: null };
		/** ***************** HIGHMARK CHECK END *********************** */

		/** ***************** VERIFY AADHAR OTP START *********************** */
		case CoApplicantActionType.VERIFY_CO_APPLICANT_AADHAR_OTP_SUCCESS:
			return {
				...state,
				verifyCoApplicantAadharOtpResp: action.payload,
				verifyCoApplicantAadharOtpResult: docodeHexResponse(
					action.payload,
					'AppVerifyKYCKey',
				),
			};

		case CoApplicantActionType.VERIFY_CO_APPLICANT_AADHAR_OTP_FAILURE:
			return { ...state, verifyCoApplicantAadharOtpResp: action.payload };

		case CoApplicantActionType.VERIFY_CO_APPLICANT_AADHAR_OTP_RESPONSE_CHANGED:
			return { ...state, verifyCoApplicantAadharOtpResp: null };
		/** ***************** VERIFY AADHAR OTP END *********************** */

		/** ***************** VALIDATE AADHAR OTP START *********************** */
		case CoApplicantActionType.VERIFY_VALIDATE_CO_APPLICANT_AADHAR_OTP_SUCCESS:
			return {
				...state,
				verifyValidateCoApplicantAadharOtpResp: action.payload,
				verifyValidateCoApplicantAadharOtpResult: docodeHexResponse(
					action.payload,
					'AppVerifyKYCKey',
				),
			};

		case CoApplicantActionType.VERIFY_VALIDATE_CO_APPLICANT_AADHAR_OTP_FAILURE:
			return { ...state, verifyValidateCoApplicantAadharOtpResp: action.payload };

		case CoApplicantActionType.VERIFY_VALIDATE_CO_APPLICANT_AADHAR_OTP_RESPONSE_CHANGED:
			return { ...state, verifyValidateCoApplicantAadharOtpResp: null };
		/** ***************** VALIDATE AADHAR OTP END *********************** */

		default:
			return state;
	}
};
